import { useState, useCallback } from 'react';
import { useMountedState } from 'react-use';
import { v4 as uuidv4 } from 'uuid';
import type { Dispatch } from 'redux';
import { useDispatch } from 'react-redux';

import {
  fetchLegalBasisFrequentlyUsed,
  fetchLegalBasisFrequentlyUsedSave,
} from 'APIPackage/CatalogsModule/services/legalBasisApi';
import { ILegalBasisDocumentExtended } from 'APIPackage/CatalogsModule/interfaces/ILegalBasisDocumentExtended';
import { coreSetLoading } from 'CorePackage/MainModule/actions/coreActions';
import { RootActions } from 'CorePackage/MainModule/types/RootActions';

export function useLegalBasisFrequentlyUsed() {
  const dispatch = useDispatch<Dispatch<RootActions>>();
  const isMounted = useMountedState();
  const [legalBasisFrequentlyUsedDocuments, setLegalBasisFrequentlyUsedDocuments] = useState<
    ILegalBasisDocumentExtended[]
  >([]);

  const getLegalBasisFrequentlyUsed = useCallback(
    async (count: number) => {
      try {
        dispatch(coreSetLoading(true));
        const documents = await fetchLegalBasisFrequentlyUsed(count);

        isMounted() &&
          setLegalBasisFrequentlyUsedDocuments(
            documents.map(document => ({
              ...document,
              id: uuidv4(),
            })),
          );
      } finally {
        dispatch(coreSetLoading(false));
      }
    },
    [dispatch, isMounted],
  );

  const saveLegalBasisFrequentlyUsed = useCallback(
    async (externalIdList: Array<string>) => {
      try {
        dispatch(coreSetLoading(true));
        fetchLegalBasisFrequentlyUsedSave(externalIdList);
      } finally {
        dispatch(coreSetLoading(false));
      }
    },
    [dispatch],
  );

  return {
    getLegalBasisFrequentlyUsed,
    saveLegalBasisFrequentlyUsed,
    legalBasisFrequentlyUsedDocuments,
  };
}
